<template>
  <register-confirmation class="mt-3" />
</template>

<script>
import RegisterConfirmation from '@/components/cleanui/system/Auth/RegisterConfirmation'

export default {
  components: {
    RegisterConfirmation,
  },
}
</script>
